<template>
  <a
    v-if="link"
    class="c-logo"
    :href="link"
    target="_blank"
    :aria-label="ariaLabelLink">
    <fagbokforlaget-logo class="c-logo__svg"/>
  </a>
</template>

<script>
import FagbokforlagetLogo from './assets/FagbokforlagetLogo.vue'

export default {
  name: 'fh-logo',

  components: {
    'fagbokforlaget-logo': FagbokforlagetLogo
  },

  props: {
    link: {
      type: String,
      default: '',
      required: true
    },
    ariaLabelLink: {
      type: String,
      default: '',
      required: true
    }
  }
}
</script>

<style lang="scss">
.c-logo {
  display: inline-flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  padding: 1.5em 0;

  &:focus {
    outline: 2px dashed #fff;
  }
  &:hover {
    opacity: 0.85;
  }
}

.c-logo__svg {
  height: 4em;
}
</style>
